// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* -----------------------------------------------------------------------------
// REGISTRO ENVIADO
// ----------------------------------------------------------------------------- */
.registro-enviado{
    margin: auto;
    width: 100%;
    align-items: center;
    justify-content: center;
    gap: 30px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.registro-enviado .check{
    background: radial-gradient(circle, rgba(42,140,74,1) 25%, rgba(255,255,255,1) 90%);
    border-radius: 50%;
    width: 150px;
    height: 150px;
    justify-content: center;
}

.registro-enviado svg{
    color: white;
    font-size: 48px;
}


/* -----------------------------------------------------------------------------
// USUARIO RECHAZADO
// ----------------------------------------------------------------------------- */
.formulario-registro .situacion{ 
    background-color: #FFDDD8;
    padding: 50px;
}

.formulario-registro.rechazo .terminos-enviar { border-top: none; }
.formulario-registro.rechazo .cerrar:hover { border: 2px solid #8E151D; }


/* -----------------------------------------------------------------------------
// NOT FOUND
// ----------------------------------------------------------------------------- */
.not-found{ 
    margin: auto;
  /*   height: calc(100vh - 350px); */
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.not-found img{ height: calc(100vh - 350px);}
.not-found section{ width: 350px;}
.not-found .numero{ font-size: 120px;}
.not-found .texto p{ font-size: 18px;}
.not-found .texto .ups{ font-size: 32px;}
`, "",{"version":3,"sources":["webpack://./src/pages/RegistroEnviado.css"],"names":[],"mappings":"AAAA;;kFAEkF;AAClF;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,mFAAmF;IACnF,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;;AAGA;;kFAEkF;AAClF;IACI,yBAAyB;IACzB,aAAa;AACjB;;AAEA,gDAAgD,gBAAgB,EAAE;AAClE,6CAA6C,yBAAyB,EAAE;;;AAGxE;;kFAEkF;AAClF;IACI,YAAY;EACd,mCAAmC;IACjC,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;;AAEA,gBAAgB,2BAA2B,CAAC;AAC5C,oBAAoB,YAAY,CAAC;AACjC,oBAAoB,gBAAgB,CAAC;AACrC,qBAAqB,eAAe,CAAC;AACrC,wBAAwB,eAAe,CAAC","sourcesContent":["/* -----------------------------------------------------------------------------\n// REGISTRO ENVIADO\n// ----------------------------------------------------------------------------- */\n.registro-enviado{\n    margin: auto;\n    width: 100%;\n    align-items: center;\n    justify-content: center;\n    gap: 30px;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n\n.registro-enviado .check{\n    background: radial-gradient(circle, rgba(42,140,74,1) 25%, rgba(255,255,255,1) 90%);\n    border-radius: 50%;\n    width: 150px;\n    height: 150px;\n    justify-content: center;\n}\n\n.registro-enviado svg{\n    color: white;\n    font-size: 48px;\n}\n\n\n/* -----------------------------------------------------------------------------\n// USUARIO RECHAZADO\n// ----------------------------------------------------------------------------- */\n.formulario-registro .situacion{ \n    background-color: #FFDDD8;\n    padding: 50px;\n}\n\n.formulario-registro.rechazo .terminos-enviar { border-top: none; }\n.formulario-registro.rechazo .cerrar:hover { border: 2px solid #8E151D; }\n\n\n/* -----------------------------------------------------------------------------\n// NOT FOUND\n// ----------------------------------------------------------------------------- */\n.not-found{ \n    margin: auto;\n  /*   height: calc(100vh - 350px); */\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n\n.not-found img{ height: calc(100vh - 350px);}\n.not-found section{ width: 350px;}\n.not-found .numero{ font-size: 120px;}\n.not-found .texto p{ font-size: 18px;}\n.not-found .texto .ups{ font-size: 32px;}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
